import {
  TYPE_KAPHA,
  TYPE_PITTA,
  TYPE_VATA,
} from './types';

export default [
  {
    answers: [
      {
        label: 'štíhlejšia',
        type: TYPE_VATA,
      },
      {
        label: 'stredná',
        type: TYPE_PITTA,
      },
      {
        label: 'silnejšia',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša postava?',
  },
  {
    answers: [
      {
        label: 'ľahšia',
        type: TYPE_VATA,
      },
      {
        label: 'stredná',
        type: TYPE_PITTA,
      },
      {
        label: 'ťažšia',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša telesná hmotnosť?',
  },
  {
    answers: [
      {
        label: 'praskajúce',
        type: TYPE_VATA,
      },
      {
        label: 'bolestivé',
        type: TYPE_PITTA,
      },
      {
        label: 'opúchajúce',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše kĺby?',
  },
  {
    answers: [
      {
        label: 'skôr skolióza',
        type: TYPE_VATA,
      },
      {
        label: 'skôr kyfóza',
        type: TYPE_PITTA,
      },
      {
        label: 'skôr lordóza',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša chrbtica?',
  },
  {
    answers: [
      {
        label: 'užšie',
        type: TYPE_VATA,
      },
      {
        label: 'stredné',
        type: TYPE_PITTA,
      },
      {
        label: 'širšie',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše boky?',
  },
  {
    answers: [
      {
        label: 'plochý',
        type: TYPE_VATA,
      },
      {
        label: 'stredný',
        type: TYPE_PITTA,
      },
      {
        label: 'veľký',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš hrudník?',
  },
  {
    answers: [
      {
        label: 'tenší',
        type: TYPE_VATA,
      },
      {
        label: 'priemerný',
        type: TYPE_PITTA,
      },
      {
        label: 'širší',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš krk?',
  },
  {
    answers: [
      {
        label: 'nevýrazné',
        type: TYPE_VATA,
      },
      {
        label: 'atletické',
        type: TYPE_PITTA,
      },
      {
        label: 'robustnejšie',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké je vaše svalstvo?',
  },
  {
    answers: [
      {
        label: 'studené',
        type: TYPE_VATA,
      },
      {
        label: 'teplé',
        type: TYPE_PITTA,
      },
      {
        label: 'vlhké',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Akú sú vaše dlane a chodidlá?',
  },
  {
    answers: [
      {
        label: 'suchá a rozpraskaná',
        type: TYPE_VATA,
      },
      {
        label: 'prekrvená s výskytom akné',
        type: TYPE_PITTA,
      },
      {
        label: 'bledá a hladká',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša pokožka?',
  },
  {
    answers: [
      {
        label: 'malé a žmurkajúce',
        type: TYPE_VATA,
      },
      {
        label: 'jasné a prenikavé',
        type: TYPE_PITTA,
      },
      {
        label: 'veľké a kľudné',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše oči?',
  },
  {
    answers: [
      {
        label: 'nepravidelný a vychýlený',
        type: TYPE_VATA,
      },
      {
        label: 'dlhý a špicatý',
        type: TYPE_PITTA,
      },
      {
        label: 'zaguľatený a gombíkový',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš nos?',
  },
  {
    answers: [
      {
        label: 'popraskané a nahnedlé',
        type: TYPE_VATA,
      },
      {
        label: 'mäkké a červené',
        type: TYPE_PITTA,
      },
      {
        label: 'plné a bledé',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše pery?',
  },
  {
    answers: [
      {
        label: 'kazovité - ustupujúce ďasná',
        type: TYPE_VATA,
      },
      {
        label: 'zažltnuté - slabá sklovina',
        type: TYPE_PITTA,
      },
      {
        label: 'biele - silné',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše zuby?',
  },
  {
    answers: [
      {
        label: 'suché, tmavé, krehké',
        type: TYPE_VATA,
      },
      {
        label: 'mastné, ryšavé, blond',
        type: TYPE_PITTA,
      },
      {
        label: 'husté, kučeravé, silné',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše vlasy?',
  },
  {
    answers: [
      {
        label: 'krehké a lámavé',
        type: TYPE_VATA,
      },
      {
        label: 'ružové a mäkké',
        type: TYPE_PITTA,
      },
      {
        label: 'široké a tučné',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše nechty?',
  },
  {
    answers: [
      {
        label: 'premenlivá',
        type: TYPE_VATA,
      },
      {
        label: 'silná',
        type: TYPE_PITTA,
      },
      {
        label: 'stabilná',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša chuť k jedlu?',
  },
  {
    answers: [
      {
        label: 'skôr nadúvanie',
        type: TYPE_VATA,
      },
      {
        label: 'skôr prekyslené',
        type: TYPE_PITTA,
      },
      {
        label: 'skôr zahlienenie',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké je vaše trávenie?',
  },
  {
    answers: [
      {
        label: 'sladká, kyslá, slaná',
        type: TYPE_VATA,
      },
      {
        label: 'sladká, horká, trpká',
        type: TYPE_PITTA,
      },
      {
        label: 'horká, pálivá, trpká',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše preferencie chuti?',
  },
  {
    answers: [
      {
        label: 'premenlivý',
        type: TYPE_VATA,
      },
      {
        label: 'silný',
        type: TYPE_PITTA,
      },
      {
        label: 'slabý',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš smäd?',
  },
  {
    answers: [
      {
        label: 'skôr tvrdá',
        type: TYPE_VATA,
      },
      {
        label: 'skôr riedka',
        type: TYPE_PITTA,
      },
      {
        label: 'skôr mastná',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša stolica?',
  },
  {
    answers: [
      {
        label: 'dýchavičnosť',
        type: TYPE_VATA,
      },
      {
        label: 'zápaly',
        type: TYPE_PITTA,
      },
      {
        label: 'nádcha',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša alergia?',
  },
  {
    answers: [
      {
        label: 'aktivita-vyčerpanosť',
        type: TYPE_VATA,
      },
      {
        label: 'intenzita-zameranosť na cieľ',
        type: TYPE_PITTA,
      },
      {
        label: 'pasívnosť-vytrvalosť',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša úroveň energie?',
  },
  {
    answers: [
      {
        label: 'tvorivý',
        type: TYPE_VATA,
      },
      {
        label: 'dobyvateľský',
        type: TYPE_PITTA,
      },
      {
        label: 'starostlivý',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš spirit?',
  },
  {
    answers: [
      {
        label: 'nerozhodnosť',
        type: TYPE_VATA,
      },
      {
        label: 'súťaživosť',
        type: TYPE_PITTA,
      },
      {
        label: 'trpezlivosť',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša mentálna aktivita?',
  },
  {
    answers: [
      {
        label: 'krátkodobá - zabúda',
        type: TYPE_VATA,
      },
      {
        label: 'strednodobá - vedomie súvislostí ',
        type: TYPE_PITTA,
      },
      {
        label: 'dlhodobá - nezabúda',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša pamäť?',
  },
  {
    answers: [
      {
        label: 'rýchla',
        type: TYPE_VATA,
      },
      {
        label: 'presvedčivá',
        type: TYPE_PITTA,
      },
      {
        label: 'kľudná',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aká je vaša reč?',
  },
  {
    answers: [
      {
        label: 'jemný',
        type: TYPE_VATA,
      },
      {
        label: 'prenikavý',
        type: TYPE_PITTA,
      },
      {
        label: 'hlboký',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš hlas?',
  },
  {
    answers: [
      {
        label: 'rýchle, tiché, nepravidelné',
        type: TYPE_VATA,
      },
      {
        label: 'impulzívne, výrazné, pravidelné',
        type: TYPE_PITTA,
      },
      {
        label: 'pomalé, hlboké, stabilné',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké je vaše dýchanie?',
  },
  {
    answers: [
      {
        label: 'neisté a nerozhodné',
        type: TYPE_VATA,
      },
      {
        label: 'podráždené a výbušné',
        type: TYPE_PITTA,
      },
      {
        label: 'tvrdohlavé a rezervované',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké je vaše chovanie?',
  },
  {
    answers: [
      {
        label: 'rýchle',
        type: TYPE_VATA,
      },
      {
        label: 'stredné',
        type: TYPE_PITTA,
      },
      {
        label: 'pomalé',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše pohyby?',
  },
  {
    answers: [
      {
        label: 'obeť-strach',
        type: TYPE_VATA,
      },
      {
        label: 'útočník-bojovnosť',
        type: TYPE_PITTA,
      },
      {
        label: 'svedok-pohodlnosť',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše emócie?',
  },
  {
    answers: [
      {
        label: 'ľahký a prerušovaný',
        type: TYPE_VATA,
      },
      {
        label: 'rýchly a ľahký',
        type: TYPE_PITTA,
      },
      {
        label: 'hlboký a dlhý',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aký je váš spánok?',
  },
  {
    answers: [
      {
        label: 'vzletné',
        type: TYPE_VATA,
      },
      {
        label: 'konfrontačné',
        type: TYPE_PITTA,
      },
      {
        label: 'romantické',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše sny?',
  },
  {
    answers: [
      {
        label: 'hudba, umenie, čítanie',
        type: TYPE_VATA,
      },
      {
        label: 'šport, politika, vzdelávanie',
        type: TYPE_PITTA,
      },
      {
        label: 'odpočinok, jedlo, priatelia',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Aké sú vaše záľuby?',
  },
];
